import React from 'react';
import PropTypes from 'prop-types';

import './Badges.scss';

import { randomNumber } from '../../common/_commonFunction';

const Badges = props => {
  if (!props.items || props.items.length === 0) {
    return null;
  }

  return (
    <div className="Badges">
      <div className="box-item">
        {
          props.items.map((ele, index) => (
            <div className="badge-item" key={randomNumber()}>
              <span className="text" id={`badge-item-${index}`}>{ele && ele.label ? ele.label : null}</span>
              <span className="box-icon" id={`badge-item-remove-${index}`} onClick={() => props.handleRemove(index)}>
                <span className="icon fas fa-times" />
              </span>
            </div>
          ))
        }
      </div>
      {props.hr ? <hr className="hr" /> : null}
    </div>
  );
};

Badges.propTypes = {
  'items': PropTypes.array,
  'handleRemove': PropTypes.func.isRequired,
  'hr': PropTypes.bool,
};

export default Badges;
